// Put all your constants in this file

// CourseTable.js

export const COURSEEXPLORERURL = 'https://courses.illinois.edu/schedule/2022/fall/';
